import { NgModule } from '@angular/core';
import { NgLwDataStudioComponent } from './ng-lw-data-studio.component';
import { LdsAppRoutingModule } from './app-routing.module';
import { DevicesComponent } from './device-components/devices/devices.component';
import { LdsUserService } from './services/lds-user.service';
import { LwProductService } from './lw-product/lw-product.service';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MainComponent } from './main/main.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DeviceCardComponent } from './device-components/device-card/device-card.component';
import { DeviceEnergyListComponent } from './device-components/device-energy-list/device-energy-list.component';
import { LdsAccessGuard } from './lds-access.guard';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DeviceHeatingListComponent } from './device-components/device-heating-list/device-heating-list.component';
import { DeviceSwitchListComponent } from './device-components/device-switch-list/device-switch-list.component';
import { LdsEnergyDetailComponent } from './device-components/lds-energy-detail/lds-energy-detail.component';
import { FeatureListComponent } from './device-components/feature-list/feature-list.component';
import { LdsGraphModule } from './lds-graph/lds-graph.module';
import { LdsEventBusService } from './services/lds-event-bus.service';
import { DemoAccountService } from './demo-account.service';
import { EnergyMainComponent } from './energy-components/energy-main/energy-main.component';
import { EnergyOverviewComponent } from './energy-components/energy-overview/energy-overview.component';
import { EnergyStatusComponent } from './energy-components/energy-status/energy-status.component';
import { FeaturesetListComponent } from './energy-components/featureset-list/featureset-list.component';
import { FeaturesetCardAllDevicesComponent } from './energy-components/featureset-card-all-devices/featureset-card-all-devices.component';
import { FeaturesetCardComponent } from './energy-components/featureset-card/featureset-card.component';
import { ClickOutSideDirective } from './click-out-side.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip'
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogRef } from '@angular/material/dialog';
import { HomeComponent, HomeConfigDialogComponent } from './home-components/home/home.component';
import { FeedbackComponent } from './feedback/feedback.component'
import { DeviceCardHeatingComponent } from './device-components/device-card-heating/device-card-heating.component';
import { HeatingDetailComponent } from './device-components/heating-detail/heating-detail.component';
import { DeviceCardSwitchComponent } from './device-components/device-card-switch/device-card-switch.component';
import { SwitchDetailComponent } from './device-components/switch-detail/switch-detail.component';
import { AboutComponent } from './about/about.component';
import { PopupComponent } from './common-components/popup/popup.component';
import { GlobalVariablesService } from './services/global-variables.service';
import { EnergyMonitorComponent } from './lw600/energy-monitor/energy-monitor.component';
import { EnergyMonitorListComponent } from './lw600/energy-monitor-list/energy-monitor-list.component';
import { EnergyMonitorCardComponent } from './lw600/energy-monitor-card/energy-monitor-card.component';
import { MotionSensorComponent } from './device-components/motion-sensor/motion-sensor.component';
import {DataExportService} from "./services/data-export.service";
import { TimeSelectComponent } from './time-select/time-select.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BatteryDeviceComponent } from './battery/battery-device/battery-device.component';
import { BatteryListComponent } from './battery/battery-list/battery-list.component';
import { WireFreeComponent } from './device-components/wire-free/wire-free.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  imports: [
    LdsAppRoutingModule,
    LdsGraphModule,
    BrowserAnimationsModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    MatSlideToggleModule,

    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,

  ],
    declarations: [
        NgLwDataStudioComponent,
        EnergyMonitorComponent,
        EnergyMonitorListComponent,
        EnergyMonitorCardComponent,
        DevicesComponent,
        SidebarComponent,
        MainComponent,
        DeviceCardComponent,
        DeviceEnergyListComponent,
        DeviceHeatingListComponent,
        DeviceSwitchListComponent,
        LdsEnergyDetailComponent,
        FeatureListComponent,
        FeaturesetCardAllDevicesComponent,
        EnergyMainComponent,
        EnergyOverviewComponent,
        EnergyStatusComponent,
        FeaturesetListComponent,
        FeaturesetCardComponent,
        ClickOutSideDirective,
        WireFreeComponent,
        HomeConfigDialogComponent,
        HomeComponent,
        FeedbackComponent,
        DeviceCardHeatingComponent,
        HeatingDetailComponent,
        DeviceCardSwitchComponent,
        SwitchDetailComponent,
        MotionSensorComponent,
        AboutComponent,
        PopupComponent,
        TimeSelectComponent,
        BatteryDeviceComponent,
        BatteryListComponent
    ],
    exports: [NgLwDataStudioComponent, HomeConfigDialogComponent, TimeSelectComponent],
    providers: [
        {
            provide: MatDialogRef,
            useValue: {}
        }
    ]
})
export class NgLwDataStudioModule { }
